module.exports = __webpack_public_path__ + "img/far-info-circle.30d697cf.svg";